var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"page-content"},[_c('Landing'),_c('Mindset'),_c('Pictures'),_c('Booking'),_c('Salon'),_c('Services'),_c('Partner'),_c('Instagram'),_c('Summary')],1)}
var staticRenderFns = []

export { render, staticRenderFns }